import React, { forwardRef, useId } from 'react';
import { cn } from '../../lib/utils';
import RequiredMark from './RequiredMark';

/**
 * لیست کشویی استاندارد پروژه (با برچسب و ستاره‌ی قرمز برای فیلد اجباری)
 */
const Select = forwardRef(function Select(
  { label, error, hint, required, className, selectClassName, id, children, ...props },
  ref
) {
  const generatedId = useId();
  const selectId = id ?? generatedId;

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {label && (
        <label htmlFor={selectId} className="text-lg font-medium text-text-dark/80">
          {label}
          {required && <RequiredMark />}
        </label>
      )}

      <select
        id={selectId}
        ref={ref}
        required={required}
        aria-required={required || undefined}
        className={cn(
          'w-full rounded-xl border-2 bg-white p-3 text-sm outline-none transition-all duration-300 focus:shadow-lg disabled:opacity-50',
          error
            ? 'border-red-400 focus:border-red-500 focus:shadow-red-500/20'
            : 'border-slate-200 focus:border-emerald-500 focus:shadow-emerald-500/20',
          selectClassName
        )}
        {...props}
      >
        {children}
      </select>

      {hint && !error && <p className="text-xs text-slate-400">{hint}</p>}
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
});

export default Select;
